<template>
  <div style="display:flex; align-items:center; height:35px; padding-left:8px; gap:8px;">
    <v-icon small color="orange" style="cursor:pointer;" @click="editEntry">mdi-pencil</v-icon>
    <v-icon small color="primary" style="cursor:pointer;" @click="viewLogs">mdi-information</v-icon>
  </div>
</template>
<script>
export default {
  methods: {
    editEntry() {
      this.params.context.parentComponent.editCommitmentEntry(this.params.data.id);
    },
    viewLogs() {
      this.params.context.parentComponent.viewCommitmentLogs(this.params.data.id);
    },
  },
};
</script>
